import React from 'react'
import styles from './style.module.scss'

const Pin = () => {
    return (
        <span className={styles.pin}>
            <img src={require('../../assets/png/二维码.png')} alt="二维码"/>
        </span>
    )
}

export default Pin;